(function(){
    'use strict';

    var coursesSortBtn = $('.courses_sort-title'),
        coursesSortList= $('.courses_sort-list');

    $('body').append('<div class="courses_bg">');
    var coursesBg = $('.courses_bg');

    
    coursesSortBtn.on('click', function(){
        coursesSortList.addClass('courses_sort-list--active');
        coursesBg.show();
    });

    coursesBg.on('click', function(){
        coursesBg.hide();
        coursesSortList.removeClass('courses_sort-list--active');
    });

})();